<template lang="pug">
div.animated.fadeIn
  b-card
    div.row
      div.col-sm-5
        h4.card-title.mb-0
          | Motor Insurance
        div.small.text-muted
          | Displaying motor insurance renewals
      div.col-sm-7.hidden-sm-down
        b-btn.pull-right(type='button', variant='primary')
          i.icon-cloud-download
          |   Export
    br
    crm-table-motor
</template>

<script>
export default {
  name: 'dashboard',
  data() {
    return {
    }
  },
  mounted: function() {
  },
}
</script>



// WEBPACK FOOTER //
// src/views/CRM/motor-insurance.vue?12dc8184